import { Component } from '@angular/core';
import { MeteredDataService, RequestMeteredDataDto } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-request-timeseries-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDirective,
  ],
  templateUrl: './request-timeseries-modal.component.html',
  styleUrl: './request-timeseries-modal.component.css'
})
export class RequestTimeseriesModalComponent implements HasUnsavedChanges {
  /** Form **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl<string | undefined>(undefined, Validators.required),
    start: new FormControl<string | null>(null, Validators.required),
    end: new FormControl<string | null>(null, Validators.required),
  });

  /** ID **/
  public id?: string;

  constructor(
    private readonly meteredDataService: MeteredDataService,
    private readonly formApiService: FormApiService,
  ) {
  }

  public submit(): void {
    /** Set ID **/
    this.form.get('meteringPointIdentification')?.setValue(this.id);

    /** Form ApiService **/
    this.formApiService.submit<RequestMeteredDataDto>(
      this.form,
      (data) => this.meteredDataService.meteredDataRequestMeteredDataPost(data),
      {
        successMessage: 'meteringpoint.timeseries.request.success',
        closeModal: true
      },
    );
  }


}
